import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, Sparkles, Check, Bot } from 'lucide-react';
import { SplineScene } from '@/components/ui/splite';
import { Spotlight } from '@/components/ui/spotlight';
import './HeroSpline.css';

const ROBOT_SCENE = 'https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode';

export const HeroSpline = () => {
  const reduced = useReducedMotion();

  const fade = {
    hidden: { opacity: 0, y: reduced ? 0 : 24 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: reduced ? 0.2 : 0.6, delay: reduced ? 0 : i * 0.1, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  return (
    <section className="hero-spline">
      <Spotlight className="hero-spline-spot" fill="#2DD4BF" />

      <div className="hero-spline-grid">
        {/* Left — copy */}
        <div className="hero-spline-content">
          <motion.div variants={fade} initial="hidden" animate="show" custom={0}>
            <Link to="/agent-studio" className="hero-badge">
              <Sparkles size={13} />
              <span>Agent Studio — Coming Soon</span>
              <span className="hero-badge-sep">·</span>
              <span className="hero-badge-cta">Join Waitlist</span>
              <ArrowRight size={12} />
            </Link>
          </motion.div>

          <motion.h1 className="hero-spline-title" variants={fade} initial="hidden" animate="show" custom={1}>
            We build AI agents that <span className="accent">work in production.</span>
          </motion.h1>

          <motion.p className="hero-spline-sub" variants={fade} initial="hidden" animate="show" custom={2}>
            Conversational bots, workflow automations, data agents, and full enterprise AI
            systems — custom-built for your stack and shipped to production. Not demos. Real agents.
          </motion.p>

          <motion.div className="hero-cta" variants={fade} initial="hidden" animate="show" custom={3}>
            <Link to="/contact" className="btn-primary">
              Book a Scoping Call <ArrowRight size={18} />
            </Link>
            <Link to="/case-studies" className="btn-secondary">
              See Our Work
            </Link>
          </motion.div>

          <motion.ul className="hero-trust" variants={fade} initial="hidden" animate="show" custom={4}>
            <li><Check size={14} /> Enterprise-grade</li>
            <li><Check size={14} /> Production-ready</li>
            <li><Check size={14} /> Custom-built for your stack</li>
          </motion.ul>
        </div>

        {/* Right — 3D robot (or static fallback under reduced motion) */}
        <div className="hero-spline-visual" aria-hidden="true">
          {reduced ? (
            <div className="hero-spline-static">
              <div className="hero-spline-static-glow" />
              <Bot size={120} strokeWidth={1.1} />
            </div>
          ) : (
            <SplineScene scene={ROBOT_SCENE} className="hero-spline-canvas" />
          )}
        </div>
      </div>
    </section>
  );
};
